import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { style: {
            display: 'flex',
            justifyContent: 'center'
          } }
const _hoisted_4 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-5 mb-2" }
const _hoisted_8 = {
  class: "mb-3",
  style: { display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', textAlign: 'left' }
}
const _hoisted_9 = { style: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start'} }
const _hoisted_10 = {
  class: "ml-4",
  style: { display: 'flex', flexDirection: 'row', flexShrink: 0 }
}
const _hoisted_11 = { key: 0 }

import { ref, onMounted, watch } from 'vue'
import { firestore as db } from '@/main'
import { collection, deleteDoc, getDocs, orderBy, query, doc, updateDoc, addDoc } from 'firebase/firestore'
import { Publication, PublicationRequest } from '@/types/Publication'
import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'

import HeaderComponent from '@/components/home/HeaderComponent.vue'
import router from '@/router'
import CommonProgress from '@/components/common/CommonProgress.vue'
import '@/styles/global.scss'


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicationsView',
  setup(__props) {

const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

const publicationsQuery = query(collection(db, 'Publications'), orderBy('year', 'desc'))
const publicationsList = ref<Publication[]>([])
const filteredPublications = ref<Publication[]>([])
const publicationTypes = ref([
  'Intl_Journals', 'Intl_Conferences', 'Domestic_Journals', 'Domestic_Conferences', 'Patent', 'Book'
])
const selectedType = ref('Intl_Journals')
const isLoading = ref(true)
const isUploading = ref(false)
const isEditMode = ref(false)
const showAddModal = ref(false)
const searchText = ref('')
const selectedId = ref('')
const newPublicationModel = ref<PublicationRequest>({
  contents: '',
  link: '',
  type: 'Intl_Journals',
  year: new Date().getFullYear().toString()
})

function filterPublications () {
  filteredPublications.value = publicationsList.value.filter(pub => pub.type === selectedType.value)
}

function uploadPublication () {
  if (newPublicationModel.value.contents === '' || newPublicationModel.value.link === '' || newPublicationModel.value.year === '') {
    alert('Please fill in all fields.')
    return
  }

  isUploading.value = true

  if (isEditMode.value && selectedId.value !== '') {
    updateDoc(doc(db, 'Publications', selectedId.value), {
      ...newPublicationModel.value
    })
      .then(() => {
        alert('Publication updated successfully.')
        const index = publicationsList.value.findIndex(p => p.id === selectedId.value)
        if (index !== -1) {
          publicationsList.value[index] = { id: selectedId.value, ...newPublicationModel.value }
          filterPublications()
        }

        isEditMode.value = false
        selectedId.value = ''
        showAddModal.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
        alert(`An error occurred while updating the publication: ${e.message}`)
      })
      .finally(() => {
        isUploading.value = false
      })
  } else {
    addDoc(collection(db, 'Publications'), {
      ...newPublicationModel.value
    })
      .then((doc) => {
        alert('Publication created successfully.')
        publicationsList.value.push({
          id: doc.id,
          ...newPublicationModel.value
        } as Publication)
        filterPublications()

        showAddModal.value = false
      })
      .catch((e: Error) => {
        console.log(e.message)
        alert(`An error occurred while creating the publication: ${e.message}`)
      })
      .finally(() => {
        isUploading.value = false
      })
  }
}

function deletePublication (pub: Publication) {
  if (confirm(`Are you sure you want to delete ${pub.contents} publication?\nThis action cannot be undone.`)) {
    isLoading.value = true

    deleteDoc(doc(db, 'Publications', pub.id))
      .then(() => {
        alert('Publication deleted successfully.')
        publicationsList.value = publicationsList.value.filter(p => p.id !== pub.id)
        filterPublications()
      })
      .catch((e: Error) => {
        console.log(e.message)
        alert(`An error occurred while deleting the publication: ${e.message}`)
      })
      .finally(() => {
        isLoading.value = false
      })
  }
}

onMounted(() => {
  getDocs(publicationsQuery)
    .then((docs) => {
      publicationsList.value = docs.docs.map(doc => ({ id: doc.id, ...doc.data() })) as Publication[]
      filterPublications()
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
    .finally(() => {
      isLoading.value = false

      if (router.currentRoute.value.query.author) {
        searchText.value = router.currentRoute.value.query.author as string
      }
    })
})

watch(showAddModal, () => {
  if (!showAddModal.value) {
    newPublicationModel.value = {
      contents: '',
      link: '',
      type: 'Intl_Journals',
      year: new Date().getFullYear().toString()
    }
  }

  isUploading.value = false
})

watch(selectedType, () => {
  filterPublications()
})

watch(searchText, () => {
  if (searchText.value === '') {
    filterPublications()
  } else {
    const searchLower = searchText.value.toLowerCase()
    filteredPublications.value = publicationsList.value.filter(pub => pub.contents.toLowerCase().includes(searchLower))
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_contents = _resolveComponent("v-card-contents")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: 'Publications',
              onOnClick: _cache[0] || (_cache[0] = ($event: any) => (showAddModal.value = true))
            })
          ]),
          _createVNode(_component_v_text_field, {
            class: "mt-5 search-bar",
            modelValue: searchText.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
            label: "Search Publications",
            "prepend-inner-icon": "mdi-magnify",
            variant: "outlined",
            color: "primary",
            "clear-icon": "mdi-close",
            clearable: "",
            "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (searchText.value = ''))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_row, {
            class: "mt-2 mb-2",
            style: {
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
        }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publicationTypes.value, (type) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "ml-2 mt-2",
                  key: type
                }, [
                  (selectedType.value === type && searchText.value === '')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        "prepend-icon": "mdi-check",
                        variant: "tonal",
                        color: "primary",
                        class: "rounded-pill"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        onClick: ($event: any) => (selectedType.value = type),
                        variant: "tonal",
                        class: "rounded-pill",
                        disabled: searchText.value !== ''
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(type), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled"]))
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(CommonProgress, { key: 0 }))
              : (!isLoading.value && filteredPublications.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" }),
                    _cache[12] || (_cache[12] = _createTextVNode(" " + _toDisplayString('No publications found'), -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPublications.value, (pub, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: pub.id,
                        style: {
                  display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto',
                  flex: '1 1 0%'
                }
                      }, [
                        (index === 0 || (index > 0 && filteredPublications.value[index].year !== filteredPublications.value[index - 1].year))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("h3", _hoisted_7, _toDisplayString(filteredPublications.value[index].year), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (searchText.value !== '')
                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                  key: 0,
                                  class: "rounded-xl mb-2",
                                  color: "primary",
                                  variant: "outlined"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(pub.type), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(pub.contents), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_v_btn, {
                              variant: "tonal",
                              href: pub.link
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" })
                              ]),
                              _: 2
                            }, 1032, ["href"]),
                            (_unref(isSignedIn) && _unref(isAdmin))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createVNode(_component_v_btn, {
                                    variant: "tonal",
                                    class: "ml-2",
                                    onClick: ($event: any) => {
                          {
                            isEditMode.value = true;
                            selectedId.value = pub.id;
                            newPublicationModel.value = {
                              contents: pub.contents,
                              link: pub.link,
                              type: pub.type,
                              year: pub.year
                            };
                            showAddModal.value = true;
                          }}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_v_btn, {
                                    variant: "tonal",
                                    color: "red",
                                    class: "ml-2",
                                    onClick: ($event: any) => (deletePublication(pub))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
          ])
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: showAddModal.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showAddModal).value = $event)),
          style: { backdropFilter: 'blur(5px)' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, {
                  class: "rounded-xl",
                  style: {"word-break":"break-word","white-space":"pre-wrap","position":"sticky","top":"0","background-color":"transparent","backdrop-filter":"blur(5px)","z-index":"1000"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { style: { alignItems: 'center', justifyContent: 'center', 'verticalAlign': 'middle' } }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isEditMode.value ? 'Edit Publication' : 'Add Publication') + " ", 1),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "red",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showAddModal.value = false)),
                          disabled: isUploading.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_contents, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      class: "mt-4",
                      modelValue: newPublicationModel.value.contents,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newPublicationModel.value.contents) = $event)),
                      label: "Contents",
                      variant: "outlined",
                      color: "primary",
                      "prepend-icon": "mdi-format-title",
                      "clear-icon": "mdi-close",
                      clearable: "",
                      "onClick:clear": _cache[5] || (_cache[5] = ($event: any) => (newPublicationModel.value.contents = '')),
                      style: { maxWidth: '100vw' }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      class: "mt-4",
                      modelValue: newPublicationModel.value.link,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newPublicationModel.value.link) = $event)),
                      label: "Link",
                      variant: "outlined",
                      color: "primary",
                      "prepend-icon": "mdi-web",
                      "clear-icon": "mdi-close",
                      clearable: "",
                      "onClick:clear": _cache[7] || (_cache[7] = ($event: any) => (newPublicationModel.value.link = '')),
                      style: { maxWidth: '100vw' }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      class: "mt-4",
                      modelValue: newPublicationModel.value.year,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newPublicationModel.value.year) = $event)),
                      label: "Year",
                      variant: "outlined",
                      color: "primary",
                      "prepend-icon": "mdi-calendar",
                      type: "number",
                      "clear-icon": "mdi-close",
                      clearable: "",
                      "onClick:clear": _cache[9] || (_cache[9] = ($event: any) => (newPublicationModel.value.year = '')),
                      style: { maxWidth: '100vw' }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_select, {
                      class: "mt-4",
                      modelValue: newPublicationModel.value.type,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newPublicationModel.value.type) = $event)),
                      items: publicationTypes.value,
                      label: "Type",
                      variant: "outlined",
                      color: "primary",
                      "prepend-icon": "mdi-tag",
                      style: { maxWidth: '100vw' }
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    (isUploading.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          color: "primary"
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          variant: "tonal",
                          color: "primary",
                          onClick: uploadPublication
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})